$(function () {
    if (!$("#phone").length) {
        return;
    }

    let countryData = window.intlTelInputGlobals.getCountryData(),
        telInput = $("#phone"),
        countries = $("#country_code");

    telInput.intlTelInput(telInput, {
        nationalMode: true,
        utilsScript: require('intl-tel-input/build/js/utils')
    });

    $.each(countryData, function (i, country) {
        countries.append($("<option></option>").attr("value", country.iso2).text(country.name));
    });

    let initialCountry = telInput.intlTelInput("getSelectedCountryData").iso2;
    countries.val(initialCountry);


    telInput.on("countrychange", function () {
        countries.val(telInput.intlTelInput("getSelectedCountryData").iso2);
        countries.trigger('change');
    });

    countries.change(function () {
        telInput.intlTelInput("setCountry", $(this).val());
        telInput.valid()
    });

    jQuery.validator.addMethod("validPhone", function () {
        return telInput.intlTelInput("isValidNumber");
    }, 'Please enter a valid phone number.');
});
